import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import includes from 'lodash/includes';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWindows as fabFaWindows,
  faApple as fabFaApple,
  faLinux as fabFaLinux,
} from '@fortawesome/free-brands-svg-icons';

import Drm from 'Components/Utility/Drm';
import ProductCover from 'Components/Utility/ProductCover';

const OrderItemSummary = ({
  item,
  order,
}) => {
  if (isEmpty(item)) return false;
  let drmPlatform = '';

  if (item.drm) {
    drmPlatform = Object.keys(item.drm).filter(p => item.drm[p])[0];
  }

  if (includes(item.name.toLowerCase(), 'voucher:') || includes(item.name.toLowerCase(), 'coupon:')) {
    drmPlatform = 'coupon';
  }
  if (includes(item.name.toLowerCase(), 'redeem:') || includes(item.name.toLowerCase(), 'redeem code:')) {
    drmPlatform = 'redeem';
  }

  const giftOrder = get(order, 'gift_order');

  const isGiftOrder = !isEmpty(giftOrder);

  return (
    <div className="review-item-summary-card">
      <ProductCover
        cover={item.cover}
        alt={`Product cover for ${item.name}`}
        displayType={item.display_type}
      />

      <div className="order-item-details-container">
        <div className="name-icons-container">
          <div className="game-name">
            {item.name}
          </div>
          {item.bundleName &&
            <div className="in-bundle">
              <FormattedMessage id="orderitemsummary.bundle" defaultMessage="Bundle: {bundleName}" values={{ bundleName: item.bundleName }} />
            </div>
          }
          {order && !!order._id &&
            <div className="purchased-date">
              <Link to={`/orders/${order._id}`}>
                {isGiftOrder ?
                  <FormattedMessage
                    id="orderitemsummary.redeemed"
                    defaultMessage="Redeemed: {purchased}"
                    values={{ purchased: <FormattedDate value={item.purchased} year="numeric" month="long" day="2-digit" /> }}
                  />
                  :
                  <FormattedMessage
                    id="orderitemsummary.purchased"
                    defaultMessage="Purchased: {purchased}"
                    values={{ purchased: <FormattedDate value={item.purchased} year="numeric" month="long" day="2-digit" /> }}
                  />
                }
              </Link>
            </div>
          }

          <div className="icons-container">
            {drmPlatform && drmPlatform !== 'drm_free' &&
              <Drm drmType={drmPlatform} />
            }
            {item.platforms &&
              <div>
                {item.platforms.windows &&
                  <FontAwesomeIcon icon={fabFaWindows} className="mr-2" />
                }
                {item.platforms.mac &&
                  <FontAwesomeIcon icon={fabFaApple} className="mr-2" />
                }
                {item.platforms.linux &&
                  <FontAwesomeIcon icon={fabFaLinux} className="mr-2" />
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

OrderItemSummary.propTypes = {
  item: PropTypes.shape({}),
  order: PropTypes.shape({}),
};

OrderItemSummary.defaultProps = {
  item: {},
  order: {},
};

export default OrderItemSummary;
